module.exports = __webpack_public_path__ + "assets/img/e275-cn.svg";